import { defineStore } from "pinia";
import Database from "@/model/Database";
import { getDatabaseManager } from "@/firebase/DatabaseManager";
import { getState } from "../AppState";
import Audit from "@/model/Auditing/Audit";
import * as StringUtils from "@/utils/StringUtils";
import { Role } from "@/model/User";
import { getAuditManager } from "@/firebase/AuditManager";
import Communication from "@/model/Communication/Communication";
import { getCommunicationManager } from "@/firebase/CommunicationManager";
import { getStoreManager } from "@/firebase/StoreManager";

interface CommunicationsState {
  communications: Communication[];
  displayUnactives: boolean;
  databases: Database[];
  selectedDatabase: Database | null;
}

export const getCommunicationsState = defineStore("CommunicationsState", {
  state: (): CommunicationsState => {
    return {
      communications: [],
      displayUnactives: false,
      databases: [],
      selectedDatabase: null,
    };
  },
  actions: {
    async setup() {
      var dbManager = getDatabaseManager();

      await dbManager.initialize();

      await getStoreManager().initialize();

      this.databases = dbManager.getDatabases();

      this.databases.sort((a, b) => a.name.localeCompare(b.name));

      this.communications = [];

      if (this.databases.length > 0 && this.selectedDatabase == null) {
        this.selectedDatabase = this.databases[0];
        this.communications = await getCommunicationManager().getCommunications(
          this.selectedDatabase.ref
        );
      }
    },
  },
});
